// Copy for activity cards (docs/design/social-plan.md, phase 6): the Activity list in Samen, the
// weekly and monthly card, sharing it and who sees it, reactions, and the news of a reaction. One
// entry per locale; every key exists in all seven (nl is the source, the rest are translations).
export const cardsCopy = {
  nl: {
    "social.activity.title": "Activiteit",
    "social.activity.samen.hint": "Kaarten en nieuws van vrienden en groepen",
    "social.activity.feed.title": "Van vrienden en groepen",
    "social.activity.empty": "Nog niets van je vrienden en groepen. Deel zelf een kaart.",
    "social.activity.more": "Meer laden",
    "social.activity.mine.title": "Jouw kaarten",
    "social.activity.mine.last.week": "Vorige week",
    "social.activity.mine.last.month": "Vorige maand",
    "social.activity.mine.hint":
      "Gemaakt op dit apparaat uit je eigen notities. Alleen aantallen en namen uit onze lijsten gaan mee, nooit je notities.",
    "social.activity.mine.empty.week":
      "Vorige week heb je niets geproefd, dus er is geen weekkaart.",
    "social.activity.mine.empty.month":
      "Vorige maand heb je niets geproefd, dus er is geen maandkaart.",
    "social.activity.share": "Deel met anderen",
    "social.activity.shared": "Gedeeld met {who}",
    "social.activity.change": "Wijzig",
    "social.activity.stop": "Stop met delen",
    "social.activity.stop.title": "Stoppen met delen?",
    "social.activity.stop.body": "De kaart verdwijnt bij anderen, met alle reacties erop.",
    "social.activity.stop.yes": "Ja, stop met delen",
    "social.activity.audience.friends": "vrienden",
    "social.activity.audience.group.one": "1 groep",
    "social.activity.audience.group.other": "{n} groepen",
    "social.activity.card.week": "{name} deelde een weekkaart",
    "social.activity.card.month": "{name} deelde een maandkaart",
    "social.activity.event.group": "{group}: {text}",
    "social.card.name.week": "weekkaart",
    "social.card.name.month": "maandkaart",
    "social.card.name.any": "kaart",
    "social.card.title.week": "Week {n}",
    "social.card.stat.wines": "wijnen",
    "social.card.stat.notes": "notities",
    "social.card.stat.sessions": "proeverijen",
    "social.card.stat.streak": "weken op rij",
    "social.card.types": "Soorten",
    "social.card.type.red": "Rood",
    "social.card.type.white": "Wit",
    "social.card.type.rose": "Rosé",
    "social.card.type.sparkling": "Mousserend",
    "social.card.type.fortified": "Versterkt",
    "social.card.type.sweet": "Zoet",
    "social.card.regions": "Regio's",
    "social.card.countries": "Landen",
    "social.card.grapes": "Druiven",
    "social.card.new": "nieuw",
    "social.card.blind": "Blind geraden: {correct} van {calls} goed",
    "social.card.badges": "Behaald",
    "social.card.badge.first-note": "Eerste slok",
    "social.card.badge.ten-grapes": "Tien druiven",
    "social.card.badge.five-countries": "Paspoort",
    "social.card.badge.first-blind-hit": "Raak geraden",
    "social.card.badge.blind-streak-3": "Hattrick",
    "social.card.share.title.week": "Deel je weekkaart",
    "social.card.share.title.month": "Deel je maandkaart",
    "social.card.share.lead":
      "Kies wie de kaart ziet. Er gaan alleen aantallen en namen uit onze lijsten mee, geen notities.",
    "social.card.share.friends": "Vrienden",
    "social.card.share.groups": "Groepen",
    "social.card.share.noGroups": "Je zit nog in geen groep.",
    "social.card.share.pick": "Kies vrienden of minstens één groep.",
    "social.card.share.submit": "Deel de kaart",
    "social.card.share.update": "Bewaar",
    "social.reaction.good-call": "Goede call",
    "social.reaction.cheers": "Proost",
    "social.reaction.wow": "Wauw",
    "social.reaction.jealous": "Jaloers",
    "social.reaction.group": "Reageer op de kaart van {name}",
    "social.reaction.own": "Reacties op je kaart",
    "social.reaction.none": "Nog geen reacties",
    "social.reaction.error": "De reactie is niet aangekomen.",
    "social.profile.cards": "Je laatste kaarten",
    "social.profile.cards.none": "Je hebt nog geen kaart gedeeld.",
    "social.profile.cards.open": "Naar Activiteit",
    "social.inbox.update.cardReaction": "{name} reageerde met {reaction} op je {card}",
    "social.inbox.update.cardReacted": "{name} reageerde op je {card}",
  },
  en: {
    "social.activity.title": "Activity",
    "social.activity.samen.hint": "Cards and news from friends and groups",
    "social.activity.feed.title": "From friends and groups",
    "social.activity.empty": "Nothing from your friends and groups yet. Share a card yourself.",
    "social.activity.more": "Load more",
    "social.activity.mine.title": "Your cards",
    "social.activity.mine.last.week": "Last week",
    "social.activity.mine.last.month": "Last month",
    "social.activity.mine.hint":
      "Made on this device from your own notes. Only counts and names from our lists go along, never your notes.",
    "social.activity.mine.empty.week": "You tasted nothing last week, so there is no weekly card.",
    "social.activity.mine.empty.month":
      "You tasted nothing last month, so there is no monthly card.",
    "social.activity.share": "Share with others",
    "social.activity.shared": "Shared with {who}",
    "social.activity.change": "Change",
    "social.activity.stop": "Stop sharing",
    "social.activity.stop.title": "Stop sharing?",
    "social.activity.stop.body": "The card disappears for others, with every reaction on it.",
    "social.activity.stop.yes": "Yes, stop sharing",
    "social.activity.audience.friends": "friends",
    "social.activity.audience.group.one": "1 group",
    "social.activity.audience.group.other": "{n} groups",
    "social.activity.card.week": "{name} shared a weekly card",
    "social.activity.card.month": "{name} shared a monthly card",
    "social.activity.event.group": "{group}: {text}",
    "social.card.name.week": "weekly card",
    "social.card.name.month": "monthly card",
    "social.card.name.any": "card",
    "social.card.title.week": "Week {n}",
    "social.card.stat.wines": "wines",
    "social.card.stat.notes": "notes",
    "social.card.stat.sessions": "tastings",
    "social.card.stat.streak": "weeks in a row",
    "social.card.types": "Types",
    "social.card.type.red": "Red",
    "social.card.type.white": "White",
    "social.card.type.rose": "Rosé",
    "social.card.type.sparkling": "Sparkling",
    "social.card.type.fortified": "Fortified",
    "social.card.type.sweet": "Sweet",
    "social.card.regions": "Regions",
    "social.card.countries": "Countries",
    "social.card.grapes": "Grapes",
    "social.card.new": "new",
    "social.card.blind": "Blind calls: {correct} of {calls} right",
    "social.card.badges": "Earned",
    "social.card.badge.first-note": "First sip",
    "social.card.badge.ten-grapes": "Ten grapes",
    "social.card.badge.five-countries": "Passport",
    "social.card.badge.first-blind-hit": "Called it",
    "social.card.badge.blind-streak-3": "Hat-trick",
    "social.card.share.title.week": "Share your weekly card",
    "social.card.share.title.month": "Share your monthly card",
    "social.card.share.lead":
      "Choose who sees the card. Only counts and names from our lists go along, no notes.",
    "social.card.share.friends": "Friends",
    "social.card.share.groups": "Groups",
    "social.card.share.noGroups": "You are not in a group yet.",
    "social.card.share.pick": "Pick friends or at least one group.",
    "social.card.share.submit": "Share the card",
    "social.card.share.update": "Save",
    "social.reaction.good-call": "Good call",
    "social.reaction.cheers": "Cheers",
    "social.reaction.wow": "Wow",
    "social.reaction.jealous": "Jealous",
    "social.reaction.group": "React to {name}'s card",
    "social.reaction.own": "Reactions to your card",
    "social.reaction.none": "No reactions yet",
    "social.reaction.error": "The reaction did not go through.",
    "social.profile.cards": "Your latest cards",
    "social.profile.cards.none": "You have not shared a card yet.",
    "social.profile.cards.open": "Go to Activity",
    "social.inbox.update.cardReaction": "{name} reacted {reaction} to your {card}",
    "social.inbox.update.cardReacted": "{name} reacted to your {card}",
  },
  de: {
    "social.activity.title": "Aktivität",
    "social.activity.samen.hint": "Karten und Neuigkeiten von Freunden und Gruppen",
    "social.activity.feed.title": "Von Freunden und Gruppen",
    "social.activity.empty":
      "Noch nichts von deinen Freunden und Gruppen. Teile selbst eine Karte.",
    "social.activity.more": "Mehr laden",
    "social.activity.mine.title": "Deine Karten",
    "social.activity.mine.last.week": "Letzte Woche",
    "social.activity.mine.last.month": "Letzter Monat",
    "social.activity.mine.hint":
      "Auf diesem Gerät aus deinen eigenen Notizen erstellt. Nur Zahlen und Namen aus unseren Listen werden mitgeschickt, nie deine Notizen.",
    "social.activity.mine.empty.week":
      "Letzte Woche hast du nichts verkostet, also gibt es keine Wochenkarte.",
    "social.activity.mine.empty.month":
      "Letzten Monat hast du nichts verkostet, also gibt es keine Monatskarte.",
    "social.activity.share": "Mit anderen teilen",
    "social.activity.shared": "Geteilt mit {who}",
    "social.activity.change": "Ändern",
    "social.activity.stop": "Nicht mehr teilen",
    "social.activity.stop.title": "Nicht mehr teilen?",
    "social.activity.stop.body": "Die Karte verschwindet für andere, samt allen Reaktionen darauf.",
    "social.activity.stop.yes": "Ja, nicht mehr teilen",
    "social.activity.audience.friends": "Freunden",
    "social.activity.audience.group.one": "1 Gruppe",
    "social.activity.audience.group.other": "{n} Gruppen",
    "social.activity.card.week": "{name} hat eine Wochenkarte geteilt",
    "social.activity.card.month": "{name} hat eine Monatskarte geteilt",
    "social.activity.event.group": "{group}: {text}",
    "social.card.name.week": "Wochenkarte",
    "social.card.name.month": "Monatskarte",
    "social.card.name.any": "Karte",
    "social.card.title.week": "Woche {n}",
    "social.card.stat.wines": "Weine",
    "social.card.stat.notes": "Notizen",
    "social.card.stat.sessions": "Verkostungen",
    "social.card.stat.streak": "Wochen in Folge",
    "social.card.types": "Arten",
    "social.card.type.red": "Rot",
    "social.card.type.white": "Weiß",
    "social.card.type.rose": "Rosé",
    "social.card.type.sparkling": "Schaumwein",
    "social.card.type.fortified": "Aufgespritet",
    "social.card.type.sweet": "Süß",
    "social.card.regions": "Regionen",
    "social.card.countries": "Länder",
    "social.card.grapes": "Trauben",
    "social.card.new": "neu",
    "social.card.blind": "Blind getippt: {correct} von {calls} richtig",
    "social.card.badges": "Erreicht",
    "social.card.badge.first-note": "Erster Schluck",
    "social.card.badge.ten-grapes": "Zehn Trauben",
    "social.card.badge.five-countries": "Reisepass",
    "social.card.badge.first-blind-hit": "Volltreffer",
    "social.card.badge.blind-streak-3": "Hattrick",
    "social.card.share.title.week": "Teile deine Wochenkarte",
    "social.card.share.title.month": "Teile deine Monatskarte",
    "social.card.share.lead":
      "Wähle, wer die Karte sieht. Nur Zahlen und Namen aus unseren Listen werden mitgeschickt, keine Notizen.",
    "social.card.share.friends": "Freunde",
    "social.card.share.groups": "Gruppen",
    "social.card.share.noGroups": "Du bist noch in keiner Gruppe.",
    "social.card.share.pick": "Wähle Freunde oder mindestens eine Gruppe.",
    "social.card.share.submit": "Karte teilen",
    "social.card.share.update": "Speichern",
    "social.reaction.good-call": "Gut getippt",
    "social.reaction.cheers": "Prost",
    "social.reaction.wow": "Wow",
    "social.reaction.jealous": "Neidisch",
    "social.reaction.group": "Auf die Karte von {name} reagieren",
    "social.reaction.own": "Reaktionen auf deine Karte",
    "social.reaction.none": "Noch keine Reaktionen",
    "social.reaction.error": "Die Reaktion ist nicht angekommen.",
    "social.profile.cards": "Deine letzten Karten",
    "social.profile.cards.none": "Du hast noch keine Karte geteilt.",
    "social.profile.cards.open": "Zur Aktivität",
    "social.inbox.update.cardReaction": "{name} hat mit {reaction} auf deine {card} reagiert",
    "social.inbox.update.cardReacted": "{name} hat auf deine {card} reagiert",
  },
  fr: {
    "social.activity.title": "Activité",
    "social.activity.samen.hint": "Cartes et nouvelles des amis et des groupes",
    "social.activity.feed.title": "Des amis et des groupes",
    "social.activity.empty":
      "Rien de la part de vos amis et groupes pour l'instant. Partagez vous-même une carte.",
    "social.activity.more": "Charger plus",
    "social.activity.mine.title": "Vos cartes",
    "social.activity.mine.last.week": "Semaine dernière",
    "social.activity.mine.last.month": "Mois dernier",
    "social.activity.mine.hint":
      "Créées sur cet appareil à partir de vos propres notes. Seuls des nombres et des noms de nos listes sont envoyés, jamais vos notes.",
    "social.activity.mine.empty.week":
      "Vous n'avez rien dégusté la semaine dernière, il n'y a donc pas de carte hebdomadaire.",
    "social.activity.mine.empty.month":
      "Vous n'avez rien dégusté le mois dernier, il n'y a donc pas de carte mensuelle.",
    "social.activity.share": "Partager avec d'autres",
    "social.activity.shared": "Partagée avec {who}",
    "social.activity.change": "Modifier",
    "social.activity.stop": "Arrêter le partage",
    "social.activity.stop.title": "Arrêter le partage ?",
    "social.activity.stop.body": "La carte disparaît pour les autres, avec toutes ses réactions.",
    "social.activity.stop.yes": "Oui, arrêter le partage",
    "social.activity.audience.friends": "les amis",
    "social.activity.audience.group.one": "1 groupe",
    "social.activity.audience.group.other": "{n} groupes",
    "social.activity.card.week": "{name} a partagé une carte hebdomadaire",
    "social.activity.card.month": "{name} a partagé une carte mensuelle",
    "social.activity.event.group": "{group} : {text}",
    "social.card.name.week": "carte hebdomadaire",
    "social.card.name.month": "carte mensuelle",
    "social.card.name.any": "carte",
    "social.card.title.week": "Semaine {n}",
    "social.card.stat.wines": "vins",
    "social.card.stat.notes": "notes",
    "social.card.stat.sessions": "dégustations",
    "social.card.stat.streak": "semaines d'affilée",
    "social.card.types": "Types",
    "social.card.type.red": "Rouge",
    "social.card.type.white": "Blanc",
    "social.card.type.rose": "Rosé",
    "social.card.type.sparkling": "Effervescent",
    "social.card.type.fortified": "Muté",
    "social.card.type.sweet": "Doux",
    "social.card.regions": "Régions",
    "social.card.countries": "Pays",
    "social.card.grapes": "Cépages",
    "social.card.new": "nouveau",
    "social.card.blind": "À l'aveugle : {correct} bonnes réponses sur {calls}",
    "social.card.badges": "Obtenus",
    "social.card.badge.first-note": "Première gorgée",
    "social.card.badge.ten-grapes": "Dix cépages",
    "social.card.badge.five-countries": "Passeport",
    "social.card.badge.first-blind-hit": "Dans le mille",
    "social.card.badge.blind-streak-3": "Triplé",
    "social.card.share.title.week": "Partagez votre carte hebdomadaire",
    "social.card.share.title.month": "Partagez votre carte mensuelle",
    "social.card.share.lead":
      "Choisissez qui voit la carte. Seuls des nombres et des noms de nos listes sont envoyés, pas de notes.",
    "social.card.share.friends": "Amis",
    "social.card.share.groups": "Groupes",
    "social.card.share.noGroups": "Vous n'êtes encore dans aucun groupe.",
    "social.card.share.pick": "Choisissez les amis ou au moins un groupe.",
    "social.card.share.submit": "Partager la carte",
    "social.card.share.update": "Enregistrer",
    "social.reaction.good-call": "Bien vu",
    "social.reaction.cheers": "Santé",
    "social.reaction.wow": "Waouh",
    "social.reaction.jealous": "Jaloux",
    "social.reaction.group": "Réagir à la carte de {name}",
    "social.reaction.own": "Réactions à votre carte",
    "social.reaction.none": "Pas encore de réactions",
    "social.reaction.error": "La réaction n'est pas passée.",
    "social.profile.cards": "Vos dernières cartes",
    "social.profile.cards.none": "Vous n'avez pas encore partagé de carte.",
    "social.profile.cards.open": "Aller à l'activité",
    "social.inbox.update.cardReaction": "{name} a réagi par {reaction} à votre {card}",
    "social.inbox.update.cardReacted": "{name} a réagi à votre {card}",
  },
  es: {
    "social.activity.title": "Actividad",
    "social.activity.samen.hint": "Tarjetas y novedades de amigos y grupos",
    "social.activity.feed.title": "De amigos y grupos",
    "social.activity.empty": "Todavía nada de tus amigos y grupos. Comparte tú una tarjeta.",
    "social.activity.more": "Cargar más",
    "social.activity.mine.title": "Tus tarjetas",
    "social.activity.mine.last.week": "Semana pasada",
    "social.activity.mine.last.month": "Mes pasado",
    "social.activity.mine.hint":
      "Creadas en este dispositivo a partir de tus propias notas. Solo se envían recuentos y nombres de nuestras listas, nunca tus notas.",
    "social.activity.mine.empty.week":
      "La semana pasada no cataste nada, así que no hay tarjeta semanal.",
    "social.activity.mine.empty.month":
      "El mes pasado no cataste nada, así que no hay tarjeta mensual.",
    "social.activity.share": "Compartir con otros",
    "social.activity.shared": "Compartida con {who}",
    "social.activity.change": "Cambiar",
    "social.activity.stop": "Dejar de compartir",
    "social.activity.stop.title": "¿Dejar de compartir?",
    "social.activity.stop.body": "La tarjeta desaparece para los demás, con todas sus reacciones.",
    "social.activity.stop.yes": "Sí, dejar de compartir",
    "social.activity.audience.friends": "amigos",
    "social.activity.audience.group.one": "1 grupo",
    "social.activity.audience.group.other": "{n} grupos",
    "social.activity.card.week": "{name} compartió una tarjeta semanal",
    "social.activity.card.month": "{name} compartió una tarjeta mensual",
    "social.activity.event.group": "{group}: {text}",
    "social.card.name.week": "tarjeta semanal",
    "social.card.name.month": "tarjeta mensual",
    "social.card.name.any": "tarjeta",
    "social.card.title.week": "Semana {n}",
    "social.card.stat.wines": "vinos",
    "social.card.stat.notes": "notas",
    "social.card.stat.sessions": "catas",
    "social.card.stat.streak": "semanas seguidas",
    "social.card.types": "Tipos",
    "social.card.type.red": "Tinto",
    "social.card.type.white": "Blanco",
    "social.card.type.rose": "Rosado",
    "social.card.type.sparkling": "Espumoso",
    "social.card.type.fortified": "Generoso",
    "social.card.type.sweet": "Dulce",
    "social.card.regions": "Regiones",
    "social.card.countries": "Países",
    "social.card.grapes": "Uvas",
    "social.card.new": "nuevo",
    "social.card.blind": "A ciegas: {correct} aciertos de {calls}",
    "social.card.badges": "Logros",
    "social.card.badge.first-note": "Primer sorbo",
    "social.card.badge.ten-grapes": "Diez uvas",
    "social.card.badge.five-countries": "Pasaporte",
    "social.card.badge.first-blind-hit": "En el clavo",
    "social.card.badge.blind-streak-3": "Triplete",
    "social.card.share.title.week": "Comparte tu tarjeta semanal",
    "social.card.share.title.month": "Comparte tu tarjeta mensual",
    "social.card.share.lead":
      "Elige quién ve la tarjeta. Solo se envían recuentos y nombres de nuestras listas, sin notas.",
    "social.card.share.friends": "Amigos",
    "social.card.share.groups": "Grupos",
    "social.card.share.noGroups": "Todavía no estás en ningún grupo.",
    "social.card.share.pick": "Elige amigos o al menos un grupo.",
    "social.card.share.submit": "Compartir la tarjeta",
    "social.card.share.update": "Guardar",
    "social.reaction.good-call": "Buen ojo",
    "social.reaction.cheers": "Salud",
    "social.reaction.wow": "Guau",
    "social.reaction.jealous": "Envidia",
    "social.reaction.group": "Reaccionar a la tarjeta de {name}",
    "social.reaction.own": "Reacciones a tu tarjeta",
    "social.reaction.none": "Aún no hay reacciones",
    "social.reaction.error": "La reacción no llegó.",
    "social.profile.cards": "Tus últimas tarjetas",
    "social.profile.cards.none": "Todavía no has compartido ninguna tarjeta.",
    "social.profile.cards.open": "Ir a Actividad",
    "social.inbox.update.cardReaction": "{name} reaccionó con {reaction} a tu {card}",
    "social.inbox.update.cardReacted": "{name} reaccionó a tu {card}",
  },
  it: {
    "social.activity.title": "Attività",
    "social.activity.samen.hint": "Schede e novità di amici e gruppi",
    "social.activity.feed.title": "Da amici e gruppi",
    "social.activity.empty": "Ancora niente dai tuoi amici e gruppi. Condividi tu una scheda.",
    "social.activity.more": "Carica altro",
    "social.activity.mine.title": "Le tue schede",
    "social.activity.mine.last.week": "Settimana scorsa",
    "social.activity.mine.last.month": "Mese scorso",
    "social.activity.mine.hint":
      "Create su questo dispositivo dalle tue note. Partono solo conteggi e nomi dalle nostre liste, mai le tue note.",
    "social.activity.mine.empty.week":
      "La settimana scorsa non hai assaggiato nulla, quindi non c'è una scheda settimanale.",
    "social.activity.mine.empty.month":
      "Il mese scorso non hai assaggiato nulla, quindi non c'è una scheda mensile.",
    "social.activity.share": "Condividi con altri",
    "social.activity.shared": "Condivisa con {who}",
    "social.activity.change": "Modifica",
    "social.activity.stop": "Smetti di condividere",
    "social.activity.stop.title": "Smettere di condividere?",
    "social.activity.stop.body": "La scheda sparisce per gli altri, con tutte le sue reazioni.",
    "social.activity.stop.yes": "Sì, smetti di condividere",
    "social.activity.audience.friends": "amici",
    "social.activity.audience.group.one": "1 gruppo",
    "social.activity.audience.group.other": "{n} gruppi",
    "social.activity.card.week": "{name} ha condiviso una scheda settimanale",
    "social.activity.card.month": "{name} ha condiviso una scheda mensile",
    "social.activity.event.group": "{group}: {text}",
    "social.card.name.week": "scheda settimanale",
    "social.card.name.month": "scheda mensile",
    "social.card.name.any": "scheda",
    "social.card.title.week": "Settimana {n}",
    "social.card.stat.wines": "vini",
    "social.card.stat.notes": "note",
    "social.card.stat.sessions": "degustazioni",
    "social.card.stat.streak": "settimane di fila",
    "social.card.types": "Tipi",
    "social.card.type.red": "Rosso",
    "social.card.type.white": "Bianco",
    "social.card.type.rose": "Rosato",
    "social.card.type.sparkling": "Spumante",
    "social.card.type.fortified": "Fortificato",
    "social.card.type.sweet": "Dolce",
    "social.card.regions": "Regioni",
    "social.card.countries": "Paesi",
    "social.card.grapes": "Vitigni",
    "social.card.new": "nuovo",
    "social.card.blind": "Alla cieca: {correct} giuste su {calls}",
    "social.card.badges": "Ottenuti",
    "social.card.badge.first-note": "Primo sorso",
    "social.card.badge.ten-grapes": "Dieci vitigni",
    "social.card.badge.five-countries": "Passaporto",
    "social.card.badge.first-blind-hit": "Azzeccato",
    "social.card.badge.blind-streak-3": "Tripletta",
    "social.card.share.title.week": "Condividi la tua scheda settimanale",
    "social.card.share.title.month": "Condividi la tua scheda mensile",
    "social.card.share.lead":
      "Scegli chi vede la scheda. Partono solo conteggi e nomi dalle nostre liste, nessuna nota.",
    "social.card.share.friends": "Amici",
    "social.card.share.groups": "Gruppi",
    "social.card.share.noGroups": "Non sei ancora in nessun gruppo.",
    "social.card.share.pick": "Scegli gli amici o almeno un gruppo.",
    "social.card.share.submit": "Condividi la scheda",
    "social.card.share.update": "Salva",
    "social.reaction.good-call": "Bel colpo",
    "social.reaction.cheers": "Salute",
    "social.reaction.wow": "Wow",
    "social.reaction.jealous": "Invidia",
    "social.reaction.group": "Reagisci alla scheda di {name}",
    "social.reaction.own": "Reazioni alla tua scheda",
    "social.reaction.none": "Ancora nessuna reazione",
    "social.reaction.error": "La reazione non è arrivata.",
    "social.profile.cards": "Le tue ultime schede",
    "social.profile.cards.none": "Non hai ancora condiviso nessuna scheda.",
    "social.profile.cards.open": "Vai ad Attività",
    "social.inbox.update.cardReaction": "{name} ha reagito con {reaction} alla tua {card}",
    "social.inbox.update.cardReacted": "{name} ha reagito alla tua {card}",
  },
  pt: {
    "social.activity.title": "Atividade",
    "social.activity.samen.hint": "Cartões e novidades de amigos e grupos",
    "social.activity.feed.title": "De amigos e grupos",
    "social.activity.empty": "Ainda nada dos teus amigos e grupos. Partilha tu um cartão.",
    "social.activity.more": "Carregar mais",
    "social.activity.mine.title": "Os teus cartões",
    "social.activity.mine.last.week": "Semana passada",
    "social.activity.mine.last.month": "Mês passado",
    "social.activity.mine.hint":
      "Criados neste dispositivo a partir das tuas próprias notas. Só seguem contagens e nomes das nossas listas, nunca as tuas notas.",
    "social.activity.mine.empty.week":
      "Na semana passada não provaste nada, por isso não há cartão semanal.",
    "social.activity.mine.empty.month":
      "No mês passado não provaste nada, por isso não há cartão mensal.",
    "social.activity.share": "Partilhar com outros",
    "social.activity.shared": "Partilhado com {who}",
    "social.activity.change": "Alterar",
    "social.activity.stop": "Deixar de partilhar",
    "social.activity.stop.title": "Deixar de partilhar?",
    "social.activity.stop.body": "O cartão desaparece para os outros, com todas as reações.",
    "social.activity.stop.yes": "Sim, deixar de partilhar",
    "social.activity.audience.friends": "amigos",
    "social.activity.audience.group.one": "1 grupo",
    "social.activity.audience.group.other": "{n} grupos",
    "social.activity.card.week": "{name} partilhou um cartão semanal",
    "social.activity.card.month": "{name} partilhou um cartão mensal",
    "social.activity.event.group": "{group}: {text}",
    "social.card.name.week": "cartão semanal",
    "social.card.name.month": "cartão mensal",
    "social.card.name.any": "cartão",
    "social.card.title.week": "Semana {n}",
    "social.card.stat.wines": "vinhos",
    "social.card.stat.notes": "notas",
    "social.card.stat.sessions": "provas",
    "social.card.stat.streak": "semanas seguidas",
    "social.card.types": "Tipos",
    "social.card.type.red": "Tinto",
    "social.card.type.white": "Branco",
    "social.card.type.rose": "Rosé",
    "social.card.type.sparkling": "Espumante",
    "social.card.type.fortified": "Fortificado",
    "social.card.type.sweet": "Doce",
    "social.card.regions": "Regiões",
    "social.card.countries": "Países",
    "social.card.grapes": "Castas",
    "social.card.new": "novo",
    "social.card.blind": "Às cegas: {correct} certas em {calls}",
    "social.card.badges": "Conquistas",
    "social.card.badge.first-note": "Primeiro gole",
    "social.card.badge.ten-grapes": "Dez castas",
    "social.card.badge.five-countries": "Passaporte",
    "social.card.badge.first-blind-hit": "Em cheio",
    "social.card.badge.blind-streak-3": "Hat-trick",
    "social.card.share.title.week": "Partilha o teu cartão semanal",
    "social.card.share.title.month": "Partilha o teu cartão mensal",
    "social.card.share.lead":
      "Escolhe quem vê o cartão. Só seguem contagens e nomes das nossas listas, sem notas.",
    "social.card.share.friends": "Amigos",
    "social.card.share.groups": "Grupos",
    "social.card.share.noGroups": "Ainda não estás em nenhum grupo.",
    "social.card.share.pick": "Escolhe os amigos ou pelo menos um grupo.",
    "social.card.share.submit": "Partilhar o cartão",
    "social.card.share.update": "Guardar",
    "social.reaction.good-call": "Boa escolha",
    "social.reaction.cheers": "Saúde",
    "social.reaction.wow": "Uau",
    "social.reaction.jealous": "Inveja",
    "social.reaction.group": "Reagir ao cartão de {name}",
    "social.reaction.own": "Reações ao teu cartão",
    "social.reaction.none": "Ainda sem reações",
    "social.reaction.error": "A reação não chegou.",
    "social.profile.cards": "Os teus últimos cartões",
    "social.profile.cards.none": "Ainda não partilhaste nenhum cartão.",
    "social.profile.cards.open": "Ir para Atividade",
    "social.inbox.update.cardReaction": "{name} reagiu com {reaction} ao teu {card}",
    "social.inbox.update.cardReacted": "{name} reagiu ao teu {card}",
  },
} as const;
